import { createAction, props } from '@ngrx/store';

import { PrintPriceRequest } from '../../models/print-setup.model';

export const fetchPrintPrice = createAction('[Print/Effect] Fetch Print Price', props<PrintPriceRequest>());

export const renameFrame = createAction('[Print/Effect] Rename Frame', props<{ id: string; title: string }>());

export const cancelRenameFrame = createAction('[Print/Effect] Cancel Rename Frame');
